import React, { FC } from 'react';

import { Box } from '@mui/material';
import cx from 'classnames';

import useStyles from './styles';

interface CategoryLabelWrapperProps {
  bgColor?: string;
  wrapperClass?: string;
}

const CategoryLabelWrapper: FC<CategoryLabelWrapperProps> = ({
  bgColor,
  wrapperClass = '',
  children,
}) => {
  const classes = useStyles(bgColor, undefined, undefined)();

  return <Box className={cx(classes.categoryLabel, wrapperClass)}>{children}</Box>;
};

export default CategoryLabelWrapper;
